import React from 'react';
import cx from './cx';

function ActionBar({ secondary, primary, className, ...props }) {
  return (
    <div className={cx('rg-actionbar', className)} {...props}>
      <div className="rg-actionbar__secondary">{secondary}</div>
      <div className="rg-actionbar__primary">{primary}</div>
    </div>
  );
}

export default ActionBar;
